import PropTypes from 'prop-types';

const ScheduleMemberType = PropTypes.shape({});

export default ScheduleMemberType;



// WEBPACK FOOTER //
// ./client/app/shared/types/scheduleMember.js